<!-- Derived from Lucide (https://lucide.dev), ISC License; portions from Feather, MIT. See LICENSE in this folder. -->
<!-- The outline's silhouette with 3-unit arcs and a 2.5-unit dot. -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      stroke="none"
      d="M4 9.5A10.5 10.5 0 0 1 14.5 20A1.5 1.5 0 0 1 11.5 20A7.5 7.5 0 0 0 4 12.5A1.5 1.5 0 0 1 4 9.5ZM4 2.5A17.5 17.5 0 0 1 21.5 20A1.5 1.5 0 0 1 18.5 20A14.5 14.5 0 0 0 4 5.5A1.5 1.5 0 0 1 4 2.5ZM7.5 19a2.5 2.5 0 1 0 -5 0a2.5 2.5 0 1 0 5 0Z"
    />
  </svg>
</template>
